export const roleEditSteps = [
  {
    target: ".j_r_bBtn",
    content: "Click this to go back to roles table.",
    placement: "bottom",
  },
  {
    target: ".j_r_name",
    content:
      "Enter or edit the name of the role. This name should be unique and descriptive.",
    placement: "bottom",
  },
  {
    target: ".j_r_dim",
    content:
      "Select the Dimension for the role. This categorizes the role based on the selected business area.",
    placement: "bottom",
  },
  {
    target: ".j_r_wt",
    content:
      "Set the Role Weight using the slider. This defines the access level — Low, Medium (Power User), or High.",
    placement: "top",
  },
  {
    target: ".r_desc",
    content:
      "Add a description for this role. This helps others understand the purpose of the role.",
    placement: "bottom",
  },
  {
    target: ".j_r_notes",
    content:
      "Use this field to add any additional notes related to the role, like instructions or special use cases.",
    placement: "bottom",
  },
  {
    target: ".j_r_sel",
    content:
      "This section allows you to define data access using Selection Criteria. Think of it like applying filters for role visibility.",
    placement: "top",
  },
  {
    target: ".j_r_save",
    content:
      "Once all changes are made, click here to save the role and exit the edit screen.",
    placement: "bottom",
  },
  {
    target: ".j_r_assU",
    content:
      "This will show all the users associated ith the role being edited",
    placement: "bottom",
  },
];
